import {
  BarChart3, Briefcase, Building2, Gem, Globe, GraduationCap, Handshake, Landmark, Lightbulb, MessagesSquare, Mic, Star, User, Users,
} from "lucide-react";

export const ICONS = {
  users: Users, user: User, lightbulb: Lightbulb, chart: BarChart3, globe: Globe, mic: Mic, handshake: Handshake,
  message: MessagesSquare, briefcase: Briefcase, landmark: Landmark, graduation: GraduationCap, building: Building2,
  star: Star, diamond: Gem,
};

export const Icon = ({ name, ...props }) => {
  const C = ICONS[name] || Star;
  return <C aria-hidden="true" {...props} />;
};
